export function getGraphqlSpecErrorHeader() {
  return {
    ['Feature-GraphQL-Spec-Errors']: true,
  };
}
